<div>
    <div class="modal-wrap" v-if="titles && limitdata">
        <div aria-hidden="true" aria-labelledby="exampleModalCenterTitle" class="modal fade" data-backdrop="static"
             data-keyboard="false" id="uploadDocumentModel" role="dialog" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content text-left">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalCenterTitle">
                            <span v-if="titles.modal_title">{{titles.modal_title}}</span>
                            <span v-else>Upload File</span>
                        </h5>
                        <button @click="closeModal($event)" aria-label="Close" class="close" data-dismiss="modal" type="button">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="error-list" v-if="validationerrors">
                            <ul class="error-msg">
                                <li :key="x" v-for="(error,x) in validationerrors">
                                    <div :key="i" v-for="(err,i) in error">
                                        <p> {{err}}</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="form-modified">
                            <!-- <error_msg :errors="ui.errors"></error_msg> -->

                            <div class="form-group" v-if="checkedvideourl == false">
                                <!-- {{limitdata}} -->
                                <!-- {{document.maxSizeInMB}} -->
                                <div class="custom-file">
                                    <input @change="OnDocumentChange($event)" accept="image/*" class="custom-file-input" id="customDocument" type="file">
                                    <label :class="{ 'error-input' : errors['image_validate']}" class="custom-file-label"
                                           for="customDocument" v-if="titles.browse_title">{{titles.browse_title}}</label>
                                    <label v-else>Browse File</label>
                                </div>

                            </div>
                            <validation-error :errors="errors" :field="'image_validate'" :isError="iserror" v-if="iserror"/>
                            <div class="form-group" v-if="checkedtitle == true">
                                <input :class="{ 'error-input' : errors['segment_title'] }" class="form-control" id="inputPassword"
                                       placeholder="Enter Title" type="text" v-model="ImageTitle"/>
                            </div>
                            <validation-error :errors="errors" :field="'segment_title'" :isError="iserror" v-if="iserror"/>

                            <div class="img-preview" v-if="ImgData.length > 0">
                                <a @click.prevent="removeUploadedFile()" class="btn round-btn" href=""><i
                                        class="fas fa-times"></i></a>

                                <img :src="ImgData" class="preview">
                                <!-- <clipper-basic class="preview" :src="ImgData"></clipper-basic> -->
                                <!-- <clipper-basic
                                :src="ImgData"
                                  ref="clipper"
                                  @load="imgLoad"
                                  ></clipper-basic> -->
                            </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button :disabled="is_uploading" @click.stop="uploadFile()" class="btn default-btn" data-dismiss="modal"
                                type="button">{{(is_uploading) ? 'Processing' : titles.btn_title}}
                        </button>
                        <button :disabled="is_uploading" @click="closeModal()" class="btn default-btn cancel" data-dismiss="modal"
                                type="button">Cancel
                        </button>
                    </div>
                    <!-- <processing_msg :is_saving="is_uploading"></processing_msg> -->
                </div>
            </div>
        </div>
    </div>
</div>
